module.exports = __webpack_public_path__ + "static/img/4505_phase_function_Paper_Points.99f4b17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4505_phase_function_Paper_Points.png
// module id = Bi7z
// module chunks = 0